import { statusMeta } from "@/mocks/site";

interface StatusBadgeProps {
  status: "ongoing" | "progress" | "concluded";
  size?: "sm" | "md";
}

const toneClasses: Record<string, string> = {
  primary: "bg-primary-100 text-primary-800 border-primary-200",
  accent: "bg-accent-100 text-accent-800 border-accent-200",
  secondary: "bg-secondary-100 text-secondary-800 border-secondary-200",
};

export default function StatusBadge({ status, size = "sm" }: StatusBadgeProps) {
  const meta = statusMeta[status];
  const sizeClass = size === "sm" ? "text-[11px] px-2 py-0.5" : "text-xs px-2.5 py-1";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border font-normal tracking-wide ${toneClasses[meta.tone]} ${sizeClass}`}
    >
      {status === "ongoing" ? (
        <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse-dot" />
      ) : (
        <i className="ri-checkbox-blank-circle-fill text-[6px]" />
      )}
      {meta.label}
    </span>
  );
}